import { Injectable, NgZone, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserState } from './user.state';
import { PermissionsService } from './permissions.service';

@Injectable({
  providedIn: 'root'
})
export class MercerGuard {
  private readonly router = inject(Router);
  private readonly userState = inject(UserState);
  private readonly ngZone = inject(NgZone);
  private readonly toast = inject(ToastrService);
  private readonly permissionsService = inject(PermissionsService);

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const isDynamicMercerAccessAllowed = this.userState.isDynamicMercerAccessAllowed();

    if (isDynamicMercerAccessAllowed || this.permissionsService.isSuperAdmin()) {
      return true;
    }
    this.toast.error('Not authorized.');
    return this.ngZone.run(() => this.router.navigate(['']));
  }
}
